/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_StepsInputs */

const en_next_steps = /** @type {(inputs: Next_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Steps`)
};

const de_next_steps = /** @type {(inputs: Next_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Schritte`)
};

/**
* | output |
* | --- |
* | "Next Steps" |
*
* @param {Next_StepsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const next_steps = /** @type {((inputs?: Next_StepsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_StepsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_next_steps(inputs)
	return en_next_steps(inputs)
});